import { useQuery } from '@tanstack/react-query'
import { tenMinutes } from '~constants/constants'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { constructUrlWithParams } from '../helpers'
import type {
  PortInfoListItem,
  PortInfoItem,
} from '~pages/pages-behind-login/port-info-page/types'

export interface GetPortInfoParams {
  portCountry?: string | string[]
  portName?: string | string[]
  terminalName?: string | string[]
  berthName?: string | string[]
  dateOfArrival?: string
  disabled?: boolean
}

export function useGetPortInfo(params: GetPortInfoParams = {}) {
  const fetchRequest = useFetch<PortInfoListItem[]>()
  const { disabled, ...queryParams } = params

  const url = constructUrlWithParams('/portinfo', queryParams)

  return useQuery({
    queryKey: ['/portinfo', queryParams],
    queryFn: () => fetchRequest(`${apiBase()}${url}`),
    staleTime: tenMinutes,
    enabled: !disabled,
  })
}

export function useGetPortInfoById(id: string | null) {
  const fetchRequest = useFetch<PortInfoItem>()

  return useQuery({
    queryKey: ['/portinfo', id],
    queryFn: () => fetchRequest(`${apiBase()}/portinfo/${id}`),
    staleTime: tenMinutes,
    enabled: !!id,
  })
}
